import { featured, heroSide, sectionStats } from '../../../mocks/news';

function fmt(n: number) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}万`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export default function Hero() {
  return (
    <section id="home" className="scroll-mt-24">
      {/* 顶部标语 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-8 md:pt-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex items-center gap-1 rounded bg-accent-100 text-accent-800 px-2.5 py-1 text-xs font-semibold">
                <i className="ri-flashlight-fill text-sm" aria-hidden="true" /> 全网最快突发爆料
              </span>
              <span className="text-xs text-foreground-400">24 小时滚动更新</span>
            </div>
            <p className="font-heading text-2xl md:text-4xl font-black leading-snug text-foreground-950">
              刷屏事件 第一时间
              <span className="text-primary-600"> 抢先看到</span>
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              爆炸性新闻、紧急插播、瞬间引爆全网的大瓜，这里速度与猛料兼备，满足你对突发热点的全部好奇心。
            </p>
          </div>
          <div className="flex flex-col gap-1.5 text-sm text-foreground-600 items-start md:items-end">
            <span className="flex items-center gap-2"><i className="ri-focus-3-line text-primary-500" aria-hidden="true" /> 溯源核实 · 标注信源等级</span>
            <span className="flex items-center gap-2"><i className="ri-time-line text-primary-500" aria-hidden="true" /> 24h 编辑值班追更</span>
            <span className="flex items-center gap-2"><i className="ri-emotion-happy-line text-primary-500" aria-hidden="true" /> 拒绝标题党 冷静吃瓜</span>
          </div>
        </div>

        {/* 主视觉区 */}
        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          {/* 头条大图 */}
          <article className="lg:col-span-7 group cursor-pointer relative overflow-hidden rounded-2xl border border-background-200">
            <div className="relative w-full h-[340px] md:h-[480px] overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center gap-1 rounded bg-primary-500 text-background-50 px-2 py-0.5 text-[11px] font-semibold">
                    <i className="ri-flashlight-fill text-xs" aria-hidden="true" />
                    {featured.tag}
                  </span>
                  <span className="text-xs text-background-200">{featured.category}</span>
                </div>
                <h2 className="font-heading text-xl md:text-[28px] font-black leading-snug text-background-50">
                  {featured.title}
                </h2>
                <p className="mt-2 hidden sm:block text-sm text-background-200/90 leading-relaxed line-clamp-2">
                  {featured.excerpt}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-background-200">
                  <span className="flex items-center gap-1"><i className="ri-fire-fill text-accent-400" aria-hidden="true" /> {fmt(featured.heat)} 热度</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" /> {featured.time}</span>
                  <span className="hidden sm:flex items-center gap-1 group-hover:gap-2 transition-all"><span>查看完整报道</span><i className="ri-arrow-right-line" aria-hidden="true" /></span>
                </div>
              </div>
            </div>
          </article>

          {/* 侧栏快讯 */}
          <div className="lg:col-span-5 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
                <span className="w-1 h-4 rounded bg-primary-500 inline-block" aria-hidden="true" />
                稍后跟进
              </h3>
              <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-hotspot-line" aria-hidden="true" /> 热度持续上涨</span>
            </div>
            {heroSide.map((item, idx) => (
              <article
                key={item.id}
                className="group cursor-pointer flex gap-3.5 items-center rounded-xl bg-background-100/70 border border-background-200 p-2.5 hover:bg-background-100 hover:border-background-300 transition"
              >
                <div className="flex items-center justify-center font-heading font-black text-xl md:text-2xl w-8 shrink-0 text-secondary-300">
                  {String(idx + 2).padStart(2, '0')}
                </div>
                <div className="relative w-24 h-20 md:w-28 md:h-24 shrink-0 rounded-lg overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="min-w-0">
                  <span className="inline-flex items-center gap-1 rounded bg-accent-100 text-accent-800 px-1.5 py-0.5 text-[11px] font-semibold mb-1">
                    <i className="ri-flashlight-fill text-xs" aria-hidden="true" /> {item.tag}
                  </span>
                  <h4 className="text-sm font-semibold leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition">
                    {item.title}
                  </h4>
                  <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1"><i className="ri-fire-line text-accent-500" aria-hidden="true" />{fmt(item.heat)}</span>
                    <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{item.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* 数据条 */}
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {sectionStats.map((s) => (
            <div key={s.label} className="rounded-xl bg-secondary-100/70 border border-secondary-200 px-4 py-3 flex items-center justify-between gap-2">
              <span className="font-heading text-xl md:text-2xl font-black text-secondary-900">{s.num}</span>
              <span className="text-xs md:text-sm text-secondary-700">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}